import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = import.meta.env.MODE === 'development'
window.Stimulus = application

// === MINIMAL DEBUG MONITORING ===
if (application.debug) {
  console.log('[DEBUG] Global monitoring initialized')
}

// Global error handler for Stimulus controllers
application.handleError = (error: Error, message: string, detail: object) => {
  console.error(`[Stimulus] ${message}`, error, detail)
  
  // In development, show detailed error
  if (application.debug) {
    console.trace()
  }
  
  // You could also send errors to a monitoring service here
  // Example: Sentry.captureException(error, { extra: { message, detail } })
}

// Log application start in development
if (application.debug) {
  console.log('[Stimulus] Application started successfully')
}

export { application }

